if (!customElements.get('nm-navigation')) {
  customElements.define('nm-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.timers = new Set();
      this.dialog = this.querySelector('[data-nm-mobile-menu]');
      this.menuButton = this.querySelector('[data-nm-menu-open]');
      this.scrim = this.querySelector('[data-nm-mega-scrim]');
      this.menus = [...this.querySelectorAll('[data-nm-mega]')];
      const options = { signal: this.abort.signal };
      this.addEventListener('pointerdown', () => { this.keyboardNavigation = false; }, options);
      this.addEventListener('keydown', () => { this.keyboardNavigation = true; }, options);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-nm-mega] > summary')) this.clearTimers();
        if (event.target.closest('[data-nm-country] > summary')) this.closeMegas();
        if (event.target.closest('[data-nm-menu-open]')) this.openMobile();
        if (event.target.closest('[data-nm-menu-close]')) this.closeMobile();
        if (event.target.closest('[data-nm-mega-close]')) this.closeMegas(true);
        if (event.target.closest('[data-nm-mega-scrim]')) this.closeMegas();

      }, options);
      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeMobile();
      }, options);
      this.dialog?.addEventListener('close', () => {
        document.documentElement.classList.remove('nm-menu-open');
        this.menuButton?.setAttribute('aria-expanded', 'false');
      }, options);
      this.dialog?.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right) this.closeMobile();
      }, options);
      this.dialog?.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, summary, [tabindex="0"]')].filter((node) => node.getClientRects().length);
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, options);
      this.menus.forEach((menu) => {
        const summary = menu.querySelector('summary');
        summary?.setAttribute('aria-expanded', 'false');
        menu.addEventListener('toggle', () => {
          summary?.setAttribute('aria-expanded', String(menu.open));
          if (menu.open) {
            this.menus.filter((other) => other !== menu).forEach((other) => { other.open = false; });
            this.querySelector('[data-nm-country]')?.removeAttribute('open');
          }
          this.updateScrim();
        }, options);
        menu.addEventListener('pointerenter', (event) => {
          if (!this.hasDesktopHover(event)) return;
          this.keyboardNavigation = false;
          this.clearTimers();
          this.schedule(() => { menu.open = true; }, 180);
        }, options);
        menu.addEventListener('pointerleave', (event) => {
          if (!this.hasDesktopHover(event)) return;
          this.clearTimers();
          this.schedule(() => {
            if (!this.keyboardNavigation || !menu.contains(document.activeElement)) menu.open = false;
          }, 250);
        }, options);
        menu.addEventListener('focusout', () => this.schedule(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }, 0), options);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (this.dialog?.open) this.closeMobile();
          else this.closeMegas(true);
          this.querySelector('[data-nm-country]')?.removeAttribute('open');
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.closeMegas();
          this.querySelector('[data-nm-country]')?.removeAttribute('open');
        }
      }, options);
      window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 990px)').matches) this.closeMobile(false);
        else this.closeMegas();
        this.updateScrim();
      }, options);
      window.addEventListener('scroll', () => this.updateScrim(), { ...options, passive: true });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.clearTimers();
      if (this.dialog?.open) this.closeMobile(false);
    }
    schedule(callback, delay) {
      const timer = window.setTimeout(() => { this.timers.delete(timer); callback(); }, delay);
      this.timers.add(timer);
    }
    hasDesktopHover(event) {
      return event.pointerType === 'mouse' && window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
    }
    clearTimers() { this.timers?.forEach((timer) => clearTimeout(timer)); this.timers?.clear(); }
    openMobile() {
      this.closeMegas();
      if (!this.dialog || this.dialog.open) return;
      this.opener = document.activeElement;
      this.dialog.showModal();
      document.documentElement.classList.add('nm-menu-open');
      this.menuButton?.setAttribute('aria-expanded', 'true');
      this.dialog.querySelector('[data-nm-menu-close]')?.focus();
    }
    closeMobile(restoreFocus = true) {
      if (!this.dialog?.open) return;
      this.dialog.close();
      document.documentElement.classList.remove('nm-menu-open');
      this.menuButton?.setAttribute('aria-expanded', 'false');
      if (restoreFocus && this.opener?.isConnected) this.opener.focus();
    }
    closeMegas(restoreFocus = false) {
      this.clearTimers();
      this.menus?.forEach((menu) => {
        if (menu.open && restoreFocus) menu.querySelector('summary')?.focus();
        menu.open = false;
      });
      this.updateScrim();
    }
    updateScrim() {
      if (!this.scrim) return;
      const hasOpenMenu = this.menus.some((menu) => menu.open);
      this.scrim.hidden = !hasOpenMenu;
      if (hasOpenMenu) this.scrim.style.top = `${this.querySelector('.nm-header').getBoundingClientRect().bottom}px`;
    }
  });
}
